import { Toast } from '@shared/components/toast';

export const INVITATION_ACTION_TOASTS: Record<string, Toast> = {
  deleteError: {
    type: 'error',
    message: 'Error deleting invited subscriber',
  },
  deleteSuccess: {
    type: 'success',
    message: 'Invitation deleted successfully',
  },
  resendError: {
    type: 'error',
    message: 'Error resending invitation',
  },
  resendSuccess: {
    type: 'success',
    message: 'Invitation resent successfully',
  },
};
